export default __webpack_public_path__ + "static/media/menu-station-right.9c1cd13d.png";